import { Analytics } from './analytics';

let printLink = $('a[href*="javascript:window.print()"]');

printLink.click((e) => {
    Analytics.sendRawEvent({
        "event": "print",
        "interaction": {
          "click_type": "print"
        }
    })
});